import { render } from "./Sent_Emails.vue?vue&type=template&id=1b4b5788"
import script from "./Sent_Emails.vue?vue&type=script&lang=js"
export * from "./Sent_Emails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__